import { useContext } from "react";
import { Redirect } from "react-router-dom";
import { AppContexts } from "../../providers";
import Dashboard from "../dashboard";
import { usePermissionsStore } from "../permissions/permissions_store";
import { getLandingPage } from "../permissions/landing-page";

export default function HomePage() {
  const { user } = useContext(AppContexts.AuthContext);
  const { canView, canEdit, permsLoaded } = usePermissionsStore();
  if (!permsLoaded) return null;
  const destination = getLandingPage({ canView, canEdit, user });
  if (destination === "/") return <Dashboard />;
  return <Redirect to={destination} />;
}
